import { Injectable, RendererFactory2, ViewEncapsulation, inject, DOCUMENT } from '@angular/core';

// https://github.com/angular/angular/issues/15776#issuecomment-291862953
@Injectable({ providedIn: 'root' })
export class LinkService {
  private rendererFactory = inject(RendererFactory2);
  private document = inject(DOCUMENT);

  /**
   * Inject the State into the bottom of the <head>
   */
  addTag(tag: LinkDefinition) {
    try {
      this.removeTag('rel="canonical"');
      const renderer = this.rendererFactory.createRenderer(this.document, {
        id: '-1',
        encapsulation: ViewEncapsulation.None,
        styles: [],
        data: {}
      });

      const link = renderer.createElement('link');
      const head = this.document.head;

      if (head === null) {
        throw new Error('<head> not found within DOCUMENT.');
      }

      Object.keys(tag).forEach((prop: string) => {
        return renderer.setAttribute(link, prop, tag[prop]);
      });

      renderer.appendChild(head, link);
    } catch (e) {
      console.error('Error within linkService : ', e);
    }
  }

  removeTag(attrSelector: string) {
    if (attrSelector) {
      try {
        const renderer = this.rendererFactory.createRenderer(this.document, {
          id: '-1',
          encapsulation: ViewEncapsulation.None,
          styles: [],
          data: {}
        });
        const head = this.document.head;
        if (head === null) {
          throw new Error('<head> not found within DOCUMENT.');
        }
        const linkTags = this.document.querySelectorAll('link[' + attrSelector + ']');
        for (const link of Array.from(linkTags)) {
          renderer.removeChild(head, link);
        }
      } catch (e) {
        console.error('Error while removing tag ' + e.message);
      }
    }
  }
}

export declare type LinkDefinition = {
  charset?: string;
  crossorigin?: string;
  href?: string;
  hreflang?: string;
  media?: string;
  rel?: string;
  rev?: string;
  sizes?: string;
  target?: string;
  type?: string;
} & {
  [prop: string]: string;
};
